module.exports = __webpack_public_path__ + "img/芒果2.ff493783.png";